
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="false"
></app-st-banner>
<br><br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <app-st-header-title [inputVal]="'Verify Your Email'"></app-st-header-title>
      <div class="container st-form">
        <div *ngIf="this.showPageErrorMessages" class="container st-form text-danger" #goUp>
          <app-st-span [inputVal]="'Please validate the following: '"></app-st-span>
          <div *ngFor="let errorMsg of this.pageErrorMessages" class="alert alert-danger" role="alert">
            <b>{{errorMsg.field}}: </b> {{errorMsg.detail}}
          </div>
          <br>
        </div>
        <div *ngIf="this.showPageSuccessMessages" class="container st-form text-danger" #goUp>
          <div *ngFor="let successMsg of this.pageSuccessMessages" class="alert alert-success" role="alert">
            <b>{{successMsg.field}}: </b> {{successMsg.detail}}
          </div>
          <br>
        </div>
        <div>
          <app-st-span [inputVal]="'A verified email is required to use your account.'"></app-st-span><br>
          <app-st-span [inputVal]="'A code has been sent to your email: ' + this.username"></app-st-span><br>
          <app-st-input-text [idVal]="'email-verification-code-text-id'" [label]="'Verification Code'" [placeHolderVal]="'Email Verification Code'"></app-st-input-text>
        </div>
        <br>
        <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
          <app-st-button [idVal]="'verify-email-button-id'" [label]="'Verify'" [primary]="true"
                                (click)="this.onVerifyEmail()"></app-st-button>
          <app-st-button [idVal]="'resend-code-to-email-button-id'" [label]="'Resend Code'" [primary]="false"
                         (click)="this.resendEmailVerificationCode()"></app-st-button>
        </div>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
      </div>

    </div>
  </div>
</div>
